/**
 * Centralized Firebase Configuration
 *
 * This file contains the core Firebase configuration and constants used across
 * all feature modules. All features MUST import from this file instead of
 * defining their own Firebase config or location arrays.
 *
 * LOCATIONS data is now managed via Firestore with real-time updates.
 * The locationsStore provides both static exports (for backwards compat)
 * and reactive hooks (for components needing live updates).
 *
 * @module shared/config/firebase
 */

// Re-export location data and helpers from the Zustand store
// These read from store state, which is updated by Firestore listener
export {
  // Static exports (initialized from bundled JSON, updated by Firestore)
  LOCATIONS,
  DEFAULT_LOCATION_ID,
  // Getter functions (read current store state)
  getLocationName,
  getLocationShortName,
  getLocationAddress,
  getLocationIds,
  // Reactive hooks for React components
  useLocations,
  useLocationsStore,
  useDefaultLocationId,
  // Type
  type Location,
} from '../store/locationsStore';

/**
 * Firebase configuration object type
 */
export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

/**
 * Core Firebase configuration for the application
 * Used by all feature modules
 */
export const firebaseConfig: FirebaseConfig = {
  apiKey: "AIzaSyALhXdZ0M_wxchnZpzCiYH_7QzDqxYmFuw",
  authDomain: "stamp-board-8b2fa.firebaseapp.com",
  projectId: "stamp-board-8b2fa",
  storageBucket: "stamp-board-8b2fa.firebasestorage.app",
  messagingSenderId: "324685030841",
  appId: "1:324685030841:web:991104fe1a8fc8dcd9c268"
};

/**
 * Firebase project ID (derived from firebaseConfig)
 * Used in collection path construction
 */
export const appId: string = firebaseConfig.projectId;

/**
 * Determine if running in production environment
 * Uses Vite's import.meta.env.MODE to check environment
 *
 * @returns true if in production, false otherwise
 */
export const isProduction = import.meta.env.MODE === 'production';
